import { SchemaYellowHiveQuote } from 'wg-api-sdk';
import { create } from 'zustand';

// Simple interface for basket items
export interface YellowHiveBasketItem {
  id: string;
  yellowhive_product_id: string;
  name: string;
  code: string;
  coverages: SchemaYellowHiveQuote['coverages'];
  insurance_company_name: string;
  total_premium: number;
  payment_interval: 'MONTHLY' | 'ANNUAL' | 'QUARTERLY' | 'HALF_ANNUAL' | 'ONCE';
  start_date?: string;
  insured_value?: number | null;
  deductible?: string | null;
  discount_percentage?: number;
  discount?: number;
}

interface FlowsProductYellowhiveBasketStore {
  basketItems: YellowHiveBasketItem[];

  // Add items to basket
  addToBasket: (item: YellowHiveBasketItem) => void;

  // Remove items from basket
  removeFromBasket: (yellowhive_product_id: string) => void;

  // Update basket item
  updateBasketItem: (
    yellowhive_product_id: string,
    updates: Partial<YellowHiveBasketItem>,
  ) => void;

  // Clear basket
  clearBasket: () => void;

  // Get total premium
  getTotalPremium: () => number;

  // Get basket count
  getBasketCount: () => number;
}

const useYellowhiveFlowProductsBasketStore =
  create<FlowsProductYellowhiveBasketStore>((set, get) => ({
    basketItems: [],

    addToBasket: (item) =>
      set((state) => ({
        basketItems: [...state.basketItems, item],
      })),

    removeFromBasket: (yellowhive_product_id) =>
      set((state) => ({
        basketItems: state.basketItems.filter(
          (item) => item.yellowhive_product_id !== yellowhive_product_id,
        ),
      })),

    updateBasketItem: (yellowhive_product_id, updates) =>
      set((state) => ({
        basketItems: state.basketItems.map((item) =>
          item.yellowhive_product_id === yellowhive_product_id
            ? { ...item, ...updates }
            : item,
        ),
      })),

    clearBasket: () =>
      set(() => ({
        basketItems: [],
      })),

    getTotalPremium: () => {
      const state = get();
      return state.basketItems.reduce(
        (sum, item) => sum + (item.total_premium || 0),
        0,
      );
    },

    getBasketCount: () => {
      const state = get();
      return state.basketItems.length;
    },
  }));

export default useYellowhiveFlowProductsBasketStore;
